import { Component } from '@inter-ikea-core/core';
import { Room } from '@inter-ikea-betrakta/viewer/dist/modules/Room';

/**
 * Component that holds the viewer room
 */
export default class ViewerRoomComponent implements Component {
  static id = 2016;
  typeId = ViewerRoomComponent.id;
  doStoreInSnapshot: boolean = true;
  serializable: boolean = false;
  room: Room;

  constructor(room: Room) {
    this.room = room;
  }

  eq() {
    return false;
  }
}
